import Button from "@krea/customer-features/shared-components/button";
import { useTranslation } from "react-i18next";

export const IdentificationButtonSMS = ({
  variant,
  disabled,
  onClick,
}: {
  variant?: "text" | "contained" | "outlined";
  disabled?: boolean;
  onClick: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <Button
      block
      size="lg"
      justify="center"
      id="sms-identification-button"
      className="tw-mx-auto tw-text-center"
      variant={variant}
      disabled={disabled}
      onClick={onClick}
    >
      {t("applicationForm.commons.identifyCustomerBySMS")}
    </Button>
  );
};
